<!-- Kabuk canlandırma (02.10.2026): eski hâli

      <dx-drop-down-button
      displayExpr="name"
      stylingMode="text"
      [dropDownOptions]="{  
        width: '10vw'  
      }" 
      [text]="themeName"
      [icon]="themeService.getCurrentThemeIcon()"
      [items]="themeSettings"
      (onItemClick)="onItemClick($event)"
    >
    </dx-drop-down-button>
-->
<!-- Tema adı yerine renk örneği (menü zemini + vurgu). DevExtreme 'template' ana düğmede uygulanmadığı için
     daire, icon sınıfı (.tema-ornek) + CSS değişkenleriyle çizilir; listede her temanın kendi örneği. -->
<span class="tema-kap" [style.--z]="ornek(themeName).zemin" [style.--v]="ornek(themeName).vurgu">
  <dx-drop-down-button
    stylingMode="text"
    icon="tema-ornek"
    displayExpr="name"
    [hint]="'Tema: ' + themeName"
    [dropDownOptions]="{ width: 190, wrapperAttr: { class: 'tema-listesi' } }"
    [items]="temaListesi"
    (onItemClick)="onItemClick($event)"
  >
  </dx-drop-down-button>
</span>
